import { render, staticRenderFns } from "./DumbappEmbed.vue?vue&type=template&id=3457f4dc&scoped=true&"
import script from "./DumbappEmbed.vue?vue&type=script&lang=js&"
export * from "./DumbappEmbed.vue?vue&type=script&lang=js&"
import style0 from "./DumbappEmbed.vue?vue&type=style&index=0&id=3457f4dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3457f4dc",
  null
  
)

export default component.exports